<template>
  <div class="schedule-board-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <ScheduleBoard />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScheduleBoard from '@/components/ScheduleBoard.vue'

export default {
  name: 'ScheduleBoardPage',
  components: {
    ScheduleBoard
  },
  metaInfo: {
    title: '스케줄 보드 - KARA DOING 활동 일정'
  }
}
</script>

<style scoped>
.schedule-board-page {
  min-height: 100vh;
  padding: 20px 0;
}

@media (max-width: 768px) {
  .schedule-board-page {
    padding: 10px 0;
  }
}
</style>
